import { apiClient } from './client';

export const gapsApi = {
  async getGaps(): Promise<{ total_gaps: number; gaps: { county?: string; district?: string; division: string; unregistered?: number; status: string }[] }> {
    const data: any = await apiClient.get('/gaps/');
    // Backend returns { total_gaps, gaps: [...] }
    if (data && typeof data === 'object' && 'gaps' in data) return data;
    // Fallback: array means legacy format
    if (Array.isArray(data)) return { total_gaps: data.length, gaps: data };
    return { total_gaps: 0, gaps: [] };
  },
};
